<template>
  <a-layout class='index animated fadeIn'>
    <a-card :bordered='false'>
      <a-tabs v-model:activeKey="search.activeKey" @change="changTabs">
        <a-tab-pane key="1" tab="发放明细"></a-tab-pane>
        <a-tab-pane key="2" tab="提现明细"></a-tab-pane>
      </a-tabs>
      <a-form ref='form' :model='search' :style="{'marginBottom':'20px'}" :initialValues="search" :onFinish='pageSearchChange' layout='inline'>
        <a-form-item label name="keywords">
          <a-input-group compact :style="{ width: '360px' }">
            <a-select v-model:value="search.key_type" style="width: 30%" @change="inputSelect">
              <a-select-option value="member_name">微信昵称</a-select-option>
              <a-select-option value="member_id">用户ID</a-select-option>
            </a-select>
            <a-input style="width: 70%" v-model:value="search.keyword" placeholder="请输入关键词进行搜索" />
          </a-input-group>
        </a-form-item>
        <a-form-item label="红包名称" name='title' v-if="search.activeKey==1">
          <a-input v-model:value="search.title" placeholder="请输入红包名称进行搜索" />
        </a-form-item>
        <a-form-item :label="search.activeKey==2?'最近状态更新时间':'时间'" name='time'>
          <a-range-picker v-model:value="time" valueFormat='YYYY-MM-DD' format='YYYY-MM-DD' @change="onChange" />
        </a-form-item>
        <a-form-item label="发放类型" v-if="search.activeKey==1">
          <a-select v-model:value="search.type" style="width:200px">
            <a-select-option value="">全部</a-select-option>
            <a-select-option value="1">会员卡生日权益</a-select-option>
            <a-select-option value="3">码奖品</a-select-option>
            <!-- <a-select-option value="4">导购扫码奖品</a-select-option> -->
          </a-select>
        </a-form-item>
        <!-- <a-form-item label="发放状态" v-if="search.activeKey==1" class="m-t-10">
          <a-select v-model:value="search.send_status" style="width:200px">
            <a-select-option value="">全部</a-select-option>
            <a-select-option value="1">发放成功</a-select-option>
            <a-select-option value="2">发放失败</a-select-option>
            <a-select-option value="3">补发成功</a-select-option>
          </a-select>
        </a-form-item> -->
        <!-- 占位 -->
        <a-form-item label="提现状态" v-if="search.activeKey==2" lass="m-t-10">
          <a-select v-model:value="search.send_status" style="width:200px">
            <a-select-option value="">全部</a-select-option>
            <a-select-option value="1">提现成功</a-select-option>
            <a-select-option value="2">提现失败</a-select-option>
            <a-select-option value="3">提现中</a-select-option>
          </a-select>
        </a-form-item>
        <a-form-item>
          <a-button type="primary" htmlType='submit' class="m-r-10">搜索</a-button>
          <!-- <a-button type="primary" @click="reissue">一键全部补发</a-button> -->
        </a-form-item>
      </a-form>
      <a-table :pagination='false' :loading='listLoading' bordered :columns='columns' :data-source='data' v-if="search.activeKey==1">
      </a-table>
            <a-table :pagination='false' :loading='listLoading' bordered :columns='withdrawColumns' :data-source='data' v-if="search.activeKey==2">
      </a-table>
      <a-pagination :style="{marginTop:'10px',textAlign:'right'}" show-size-changer show-quick-jumper :current="search.page" :page-size="search.limit" :total="total" @change="pageCurrentChange" @showSizeChange="pageSizeChange"  :show-total="total => `总数: ${total} `" />
    </a-card>
  </a-layout>
</template>
<script>
import { ref, onMounted, reactive, toRefs, h } from "vue";
import { message, Modal } from "ant-design-vue";
import {
  getUserBalance,
  getUserBalanceList,
  reissueUserBonus,
} from "@/api/red";
import { iscode } from "@/utils/app";
// 初始化默认筛选项数值
let defSearch = {
  activeKey: "1",
  page: 1,
  limit: 10,
  type: "",
  start_time: "",
  end_time: "",
  send_status: "",
  key_type: "member_name",
  keyword: "",
};
export default {
  setup(props, ctx) {
    // // 初始化 分页信息和筛选项信息
    let search = ref({ ...defSearch });
    // 列表数据和列头配置
    let data = ref([]);
    const state = reactive({
      list: [],
      listLoading: false,
      time: [],
      total: 1,
      level: null,
      activeKey: 1,
    });
    let columns = [
      {
        title: "微信昵称",
        dataIndex: "member_name",
        key: "member_name",
        customRender: function ({ record }) {
          return h(
            "div",
            {
              style: {
                display: "flex",
                "align-items": "center",
                height: "60px",
              },
            },
            [
              h(
                "img",
                {
                  src:
                    record.headimgurl || require("@/assets/images/normal.png"),
                  style: {
                    width: "60px",
                    height: "60px",
                    marginRight: "20px",
                  },
                },
                ""
              ),
              record.member_name || "-",
            ]
          );
        },
      },
          {
        title: "id",
        dataIndex: "member_id",
        key: "member_id",
      },
      {
        title: "标题",
        dataIndex: "title",
        key: "title",
      },
      {
        title: "红包金额",
        dataIndex: "amount",
        key: "amount",
      },
      // {
      //   title: "发放类型",
      //   dataIndex: "amount",
      //   key: "amount",
      // },
      // {
      //   title: "发放状态",
      //   dataIndex: "amount",
      //   key: "amount",
      // },
      {
        title: "领取时间",
        dataIndex: "create_time",
        key: "create_time",
      },
    ];
    let withdrawColumns = [
      {
        title: "微信昵称",
        dataIndex: "member_name",
        key: "id",
        customRender: function ({ record }) {
          return h(
            "div",
            {
              style: {
                display: "flex",
                "align-items": "center",
                height: "60px",
              },
            },
            [
              h(
                "img",
                {
                  src:
                    record.headimgurl || require("@/assets/images/normal.png"),
                  style: {
                    width: "60px",
                    height: "60px",
                    marginRight: "20px",
                  },
                },
                ""
              ),
              record.member_name || "-",
            ]
          );
        },
      },
      {
        title: "提现金额",
        dataIndex: "amount",
        key: "amount",
      },
      {
        title: "提现状态",
        dataIndex: "send_status_text",
        key: "send_status_text",
      },
      {
        title: "业务单号",
        dataIndex: "billno",
        key: "billno",
      },
      {
        title: "最近状态更新时间",
        dataIndex: "update_time",
        key: "update_time",
      },
    ];
    const tableColumns=ref([])
    // 页面筛选项搜索
    const pageSearchChange = () => {
      search.value = { ...search.value, page: 1 };
      initData(search.value);
    };
    // 分页当前页切换
    const pageCurrentChange = (page, pageSize) => {
      search.value.page = page;
      initData(search.value);
    };
    // 分页当前页显示多少条切换
    const pageSizeChange = (current, limit) => {
      search.value.page = 1;
      search.value.limit = limit;
      initData(search.value);
    };
    // 时间筛选
    const onChange = (e) => {
      search.value.start_time = e[0];
      search.value.end_time = e[1];
      initData(search.value);
    };
    const initData = async () => {
      state.listLoading = true;
      data.value = [];
      state.total = 0;
      try {
        var res;
        if (search.value.activeKey == 1) {
          res = await getUserBalance(search.value).then((res) => res.data);
        } else {
          res = await getUserBalanceList(search.value).then((res) => res.data);
        }
        state.listLoading = false;
        if (iscode(res)) {
          data.value = res.data.data;
          state.total = res.data.total;
        } else {
          message.error(res.msg);
        }
      } catch (e) {
        state.listLoading = false;
      }
    };
    onMounted(() => {
      tableColumns.value=columns
      initData(search.value);
    });
    const inputSelect = (e) => {
      search.value.keywords = "";
    };
    const changTabs = () => {
      if(search.value.activeKey==1){
        tableColumns.value=columns
      }else{
        tableColumns.value=withdrawColumns
      }
      search.value.page = 1;
      initData(search.value);
    };
    // 补发
    const reissue = () => {
      Modal.confirm({
        centered: true,
        title: "温馨提示",
        content: "确定要一键补发全部红包么?",
        onOk: async () => {
          let res = await reissueUserBonus()
            .then((res) => res.data)
            .catch((error) => error);
          if (iscode(res, true)) {
            initData();
          }
        },
      });
    };
    return {
      ...toRefs(state),
      search,
      data,
      columns,
      pageSearchChange,
      pageCurrentChange,
      pageSizeChange,
      onChange,
      inputSelect,
      tableColumns,
      withdrawColumns,
      changTabs,
      reissue,
    };
  },
};
</script>